import { useVariant } from '@unleash/proxy-client-react';
import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { selectUnleashToggle } from 'selectors/features';

export const useUnleashKillswitch = (featureFlag: string) => {
  useVariant(featureFlag);

  const isKillswitchOn = useSelector((state: AppState) => selectUnleashToggle(featureFlag, state))?.enabled;

  return { isKillswitchOn };
};
